import {QrScanner} from "@yudiel/react-qr-scanner";
import React, {useEffect, useState} from "react";
import {Outlet, redirect, useNavigate} from "react-router-dom";
import Navbar from "../../components/navbar";
import BottomBar from "../../components/bottomBar";
import Loader from "../../components/loader";
import {useRecoilState} from "recoil";
import {loaderState, userState} from "../../states/common";
import QRCode from 'react-qr-code';
import Icon from "../../components/icon";
import * as SBService from "../../helpers/sportbookService";
import * as _ from "lodash";
import {TECarousel, TECarouselItem, TEModal, TEModalBody, TEModalContent, TEModalDialog} from "tw-elements-react";
import {getAssetFullUrl} from "../../helpers/utils";
import ExpertCard from "../../components/expertCard";
import TIcon from "../../components/ui/TIcon";
import logoIcon from "statics/images/biadi-logo-icon.png";
import toast from "react-hot-toast";
import {Sheet} from "react-modal-sheet";
import "../league/shared/league.css";

const initials = (name: string) =>
    name.split(' ').filter(Boolean).slice(-2).map((w) => w[0]).join('').toUpperCase();

const MyQR = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useRecoilState(loaderState)
    const [user, setUser] = useRecoilState(userState)
    const [showModal, setShowModal] = useState(false);
    const [experts, setExperts] = useState([{}])
    const [myLeagues, setMyLeagues] = useState<any[]>([])
    /* Một sheet, hai bước - KHÔNG phải hai sheet đóng mở lẫn nhau.
     *
     * Chuyên gia đi 'mucDich' -> 'chonGiai'; cơ thủ vào thẳng 'chonGiai'. Dựng
     * hai sheet riêng thì bước một phải đóng rồi bước hai mới mở, và người dùng
     * thấy tấm nền tối chớp một cái ở giữa. */
    const [buoc, setBuoc] = useState<'dong' | 'mucDich' | 'chonGiai'>('dong')

    /* "Chỉ là cơ thủ" = KHÔNG phải chuyên gia.
     *
     * Đọc cả hai chỗ vì payload có cả hai: cờ phẳng user.isExpert (chỗ duy nhất
     * trong app đang rẽ nhánh theo vai trò cho máy quét, xem
     * scanQR.dispatchGenericCode) và user.roles.isExpert.
     *
     * KHÔNG xét isReferee: cờ đó có trong kiểu dữ liệu nhưng chưa một chỗ nào
     * trong app dùng tới, và trọng tài thì vẫn là cơ thủ khi họ tự đi thi đấu.
     * Thêm điều kiện chưa có tiền lệ là tự dựng ra một luật không ai kiểm được. */
    const laChuyenGia = !!(user?.isExpert || user?.roles?.isExpert)

    useEffect(() => {
        document.title = "Biadi — Mã QR của tôi"
        getExperts()
        const loadUser = async () => {
            try {
                const rsp = await SBService.myProfile()
                if (rsp.data) {
                    setUser(rsp.data)
                } else {
                    setUser(rsp)
                }
            } catch (e: any) {
                navigate('/auth/login')
            }
        }
        if (_.isEmpty(user.id)) {
            loadUser()
        }
    }, [])

    /* Giải đang tham gia, để quét ngay tại đây thay vì phải đi qua một màn danh
       sách nữa. NOT_ENDED lọc sẵn bên backend nên không phải lọc lại ở client. */
    useEffect(() => {
        if (!user.id) return
        let cancelled = false
        const loadLeagues = async () => {
            const rsp = await SBService.getLeagues({
                page: 1,
                limit: 20,
                onlyMyLeagues: true,
                filter: 'NOT_ENDED',
            }).catch(() => null)
            if (!cancelled) {
                setMyLeagues(Array.isArray(rsp?.data) ? rsp.data : [])
            }
        }
        loadLeagues()
        return () => {
            cancelled = true
        }
    }, [user.id])

    const getExperts = async () => {
        try {
            const expertLists = await SBService.getExperts(3)
            setExperts(expertLists.data)
        } catch (e: any) {
            if (e.response && e.response.data && e.response.data.error) {
                switch (e.response.data.error) {
                    default:
                        toast.error('Lỗi, ' + e.response.data.error)
                        break;
                }
            } else {
                toast.error('Không thể tải danh sách Expert')
            }
        }

    }

    /**
     * Bấm "Quét mã QR".
     *
     * Chưa thẩm định trình thì chưa thi đấu được — mở danh sách chuyên gia thay
     * vì để họ quét xong mới ăn lỗi.
     *
     * CHUYÊN GIA làm được HAI việc với cùng một mã cơ thủ: thẩm định trình, hoặc
     * thi đấu như mọi người. Trước đây nút này mặc định họ luôn muốn thẩm định -
     * chuyên gia muốn tự đi đánh một trận thì phải tìm xuống danh sách "Quét
     * nhanh" phía dưới. Nay hỏi thẳng: Thi đấu hay Đánh giá trình độ.
     *
     * CƠ THỦ chỉ có một việc nên không hỏi, vào luôn bước chọn giải. Quét đối thủ
     * LUÔN phải biết trận thuộc giải nào, và hỏi sau khi người ta đã giơ điện
     * thoại lên thì đã muộn.
     *
     * Chưa thẩm định trình thì chưa thi đấu được — mở danh sách chuyên gia thay
     * vì để họ quét xong mới ăn lỗi.
     */
    const handleNavigationScan = () => {
        if (!user?.isCalibrated && !laChuyenGia) {
            setShowModal(true)
            return
        }
        setBuoc(laChuyenGia ? 'mucDich' : 'chonGiai')
    }

    const quetChoGiai = (leagueId: string) => {
        setBuoc('dong')
        navigate(`/scan-qr/${leagueId}`)
    }

    /* Máy quét ở chế độ thẩm định: quét xong đi thẳng vào màn đánh giá trình độ
       của người vừa quét. Dùng đường /scan-qr/ranking có sẵn thay vì /scan-qr
       chung - máy quét chung phải tự đoán ý người quét theo vai trò, mà giờ ý đó
       đã được hỏi rõ ngay trên sheet. */
    const danhGiaTrinhDo = () => {
        setBuoc('dong')
        navigate('/scan-qr/ranking')
    }


    return <div className="">
        <Navbar title="QR của tôi"/>

        {/* Bố cục theo bản thiết kế: ảnh đại diện, tên kèm dấu đã thẩm định, mã
            QR trên nền sáng, rồi nút quét. Giữ bảng màu và component của
            platform thay vì nền xanh của bản mock. */}
        <div className="qr-screen">
            <span className="avatar avatar-ring qr-avatar">
                {user.profilePicture
                    ? <img src={user.profilePicture} alt=""/>
                    : initials(user.name || '?')}
            </span>

            <div className="qr-name">
                <span>{user.name || '—'}</span>
                {/* Dấu tích = tài khoản đã xác minh, khác với đã thẩm định
                    trình (isCalibrated) — hai chuyện không liên quan nhau.
                    Dùng icon "check" vì nó đã có mặt trong app; tên icon lạ mà
                    webfont không có thì render ra ô trống. */}
                {user.isVerified ? <TIcon name="check" className="verified"/> : null}
            </div>
            <div className="qr-sub">
                {user.isCalibrated
                    ? `Hạng cơ ${user.ranking?.code ?? '--'}`
                    : 'Chưa thẩm định trình'}
            </div>

            <div className="qr-card">
                <QRCode size={220} value={user.id || ' '}/>
            </div>
            <p className="qr-hint">Đưa mã này cho đối thủ quét để bắt đầu trận.</p>

            <button type="button" className="btn btn-primary btn-block qr-scan-btn"
                    onClick={handleNavigationScan}>
                <TIcon name="qrcode"/>
                <span>QUÉT MÃ QR</span>
            </button>
        </div>

        <Sheet snapPoints={[0.6]} initialSnap={0} isOpen={buoc !== 'dong'} onClose={() => setBuoc('dong')}>
            <Sheet.Container>
                <Sheet.Header>
                    <h3 className="text-2xl uppercase p-4 w-full text-center">
                        {buoc === 'mucDich' ? 'Quét mã để làm gì?' : 'Quét cho giải nào?'}
                    </h3>
                </Sheet.Header>
                <Sheet.Content>
                    <div className="sheet-container-scroller px-3 pb-4">
                        {buoc === 'mucDich' ? (
                            <>
                                <button type="button" className="ui-card event-card w-full text-left"
                                        onClick={() => setBuoc('chonGiai')}>
                                    <div className="info">
                                        <span className="name">Thi đấu</span>
                                        <span className="meta">Quét đối thủ để bắt đầu một trận trong giải</span>
                                    </div>
                                    <span className="btn btn-sm btn-outline">CHỌN</span>
                                </button>
                                <button type="button" className="ui-card event-card w-full text-left"
                                        onClick={danhGiaTrinhDo}>
                                    <div className="info">
                                        <span className="name">Đánh giá trình độ</span>
                                        <span className="meta">Quét cơ thủ để thẩm định và chấm hạng</span>
                                    </div>
                                    <span className="btn btn-sm btn-outline">CHỌN</span>
                                </button>
                            </>
                        ) : (
                            <>
                                {/* Chuyên gia vào đây từ bước trước, nên phải có đường lùi.
                                    Cơ thủ vào thẳng bước này nên không hiện nút lùi - lùi
                                    về một bước họ chưa từng đi qua là vô nghĩa. */}
                                {laChuyenGia ? (
                                    <button type="button" className="btn btn-sm btn-quiet mb-3"
                                            onClick={() => setBuoc('mucDich')}>
                                        ← Quay lại
                                    </button>
                                ) : null}
                                {myLeagues.length > 0 ? (
                                    myLeagues.map((l: any) => (
                                        <button key={l.id} type="button"
                                                className="ui-card event-card w-full text-left"
                                                onClick={() => quetChoGiai(l.id)}>
                                            <img className="date-box" alt=""
                                                 src={l.logo ? getAssetFullUrl(l.logo) : logoIcon}
                                                 style={{objectFit: 'cover'}}/>
                                            <div className="info">
                                                <span className="name">{l.name}</span>
                                                <span className="meta">
                                                    {l.venues?.[0]?.name ?? 'Đang cập nhật địa điểm'}
                                                </span>
                                            </div>
                                            {/* span chứ không phải button: cả dòng ĐÃ là một
                                                button, lồng button trong button là HTML sai. */}
                                            <span className="btn btn-sm btn-outline">QUÉT</span>
                                        </button>
                                    ))
                                ) : (
                                    /* Chưa tham gia giải nào thì KHÔNG mở camera: máy quét
                                       sẽ chỉ báo "mã này chưa dùng được ở đây" sau khi
                                       người ta đã giơ điện thoại lên. Dẫn đi đăng ký. */
                                    <div className="text-center py-6">
                                        <p className="mb-4">Bạn chưa tham gia giải nào đang diễn ra.</p>
                                        <button type="button" className="btn btn-primary"
                                                onClick={() => {
                                                    setBuoc('dong')
                                                    navigate('/league')
                                                }}>
                                            Xem các giải đang mở
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={() => setBuoc('dong')}/>
        </Sheet>

        <TEModal className="zIndexTop" show={showModal} setShow={setShowModal}>
            <TEModalDialog className="h-full" centered={true}>
                <TEModalContent>
                    <TEModalBody className="bg-[#131A28] text-center border border-[#242D40] rounded">
                        <div className="w-full text-left border border-dotted rounded-[0.5rem] py-2 px-4">
                            <p className="font-exo text-sm font-medium uppercase text-[#FFE7B3]">TÀI KHOẢN CHƯA KHẢO
                                HẠCH!</p>
                            <p className="font-exo text-[#FFCA16] text-[14px]">Điểm và xếp hạng của bạn chưa được thẩm
                                định. Vui lòng liên hệ các chuyên gia bên dưới.</p>
                        </div>
                        <div>
                            <div className="w-full bg-[#131A28] p-3 mt-6 text-left">
                                <table className="table-auto w-full border-spacing-2">
                                    <thead className="text-xs uppercase font-medium text-left">
                                    <tr className="h-[40px] align-top color-[#8B92A6]">
                                        <th className="font-normal" colSpan={2}>Chuyên gia</th>
                                        <th className="font-normal text-center">Xếp hạng</th>
                                        <th className="font-normal  text-center">Điểm</th>
                                    </tr>
                                    </thead>


                                    {experts.length && !_.isEmpty(experts[0]) ?
                                        <tbody className="mt-4">
                                        {experts.map((expert, index) => {
                                            return <ExpertCard key={`expert-list-${index}`} data={expert}/>
                                        })
                                        }
                                        </tbody>
                                        : <></>}
                                </table>
                            </div>
                        </div>
                        <button onClick={() => setShowModal(false)}
                                className="block w-full h-12 btn-primary text-center text-lg button-custom-shadow mt-6 mr-2"
                        >Đã hiểu
                        </button>
                    </TEModalBody>

                </TEModalContent>
            </TEModalDialog>
        </TEModal>

        {loader ? <Loader/> : <div/>}
    </div>
}

export default MyQR